import {inject, LogManager, NewInstance, PLATFORM} from 'aurelia-framework';
import {HttpClient} from 'aurelia-http-client';
import {client, usBankAccount, vaultManager, Client, USBankAccount, VaultManager} from 'braintree-web';
import {handleResponse} from '../tools/http/http';
import validator from 'us-bank-account-validator';

const logger = LogManager.getLogger('billingService');
logger.setLevel(LogManager.logLevel.debug);

@inject(NewInstance.of(HttpClient), client, usBankAccount, vaultManager )
export class BillingService {

  __httpClient: HttpClient;
  client: Client;
  usBankAccount: USBankAccount;
  vaultManager: VaultManager;
  clientToken: any;
  clientInstance: any;
  paymentMethods: any[];
  clientId: string;

  constructor(httpClient,  client, usBankAccount, vaultManager) {
    this.__httpClient = httpClient.configure(x => {
      x.withHeader('pragma', 'no-cache');
      x.withHeader('cache-control', 'no-cache');
    });
    this.client = client;
    this.usBankAccount = usBankAccount;
    this.vaultManager = vaultManager;
    this.clientToken = null;
    this.clientInstance = null;
    this.paymentMethods = [];
    this.clientId ="";
  }

  initialize(clientId, accType, guid) {
    this.clientId = clientId;
    let {response} = this.getClientToken(accType,guid);
    response.then(async (data) => {
      if (data) {
        this.clientToken = data;
        let clientInstance = await this.getClientInstance(data);
        if (clientInstance) {
          this.clientInstance = clientInstance;
        }
      }
      this.getPaymentMethods();
    });
    return this;
  }


  getClientToken(accountType, guid) {

      return handleResponse(this.__httpClient.get('billing/billingClientToken/' + accountType +"/"+ guid));


  }

  getClientInstance(clientToken) {
    return this.client.create({authorization: clientToken});
  }

  getPaymentMethods(){
    (this.vaultManager as any).create({
      client: this.clientInstance
    }, (vaultErr, vaultInstance) => {
          if (vaultErr) {
            console.error('Error getting vault:', vaultErr);
            return;
          }
          vaultInstance.fetchPaymentMethods((err, paymentMethods)=>{
            if(err){
              console.error('Error getting paymentMethods:', err);
              return;
            }
            this.paymentMethods = paymentMethods;
            //trigger event
            PLATFORM.global.dispatchEvent(new Event('braintreeWebInitialized'));

            return paymentMethods;

      });
    });
  }

  __addPaymentMethodACH(data){
    return handleResponse(this.__httpClient.post('billing/paymentMethod', data));
  }
  __createACHPayment(data){
    return handleResponse(this.__httpClient.post('fe/billing/transactionACH', data));
  }

  addPaymentMethodACH(requestData, authorization, callbackFunction, errorFunction){
    this.usBankAccount.create({
      client: this.clientInstance
    }, (usBankAccountErr, usBankAccountInstance) => {
      if (usBankAccountErr) {
        //console.error('There was an error creating the USBankAccount instance.');
        errorFunction(usBankAccountErr);
        throw usBankAccountErr;
      }
      usBankAccountInstance.tokenize({
        bankDetails: requestData,
        mandateText: authorization
      }, (tokenizeErr, tokenizedPayload) => {
        if (tokenizeErr) {
          //console.error('There was an error tokenizing the bank details.');
          if(tokenizeErr.details && tokenizeErr.details.originalError && tokenizeErr.details.originalError.details && tokenizeErr.details.originalError.details.originalError && tokenizeErr.details.originalError.details.originalError.error && tokenizeErr.details.originalError.details.originalError.error.details){
            errorFunction(tokenizeErr.details.originalError.details.originalError.error.details)
          }else{
            errorFunction([]);
          }return;
        }
        // Send tokenizePayload.nonce to your server here!
        // Tokenization succeeded
        let {response} = this.__addPaymentMethodACH({
          'payment_profile':{
            'firstName': requestData.firstName ? requestData.firstName : requestData.businessName,
              'lastName': requestData.lastName ? requestData.lastName : "",
              'customerACH': requestData.customerACH,
              'subscriptionId': requestData.subscriptionId,
              'nonce': tokenizedPayload.nonce,
              'payment_type': 'bank_account',
              'type':requestData.type,
              'guid':requestData.guid,
              'billingAddress':requestData.billingAddress
          }
        });
        response.then((data)=>{
            if(data.payment_profile && data.payment_profile.customer_id && data.payment_profile.customer_id!=this.clientId){
              this.initialize(data.payment_profile.customer_id,requestData.type,requestData.guid);
            }
            console.log(data);
            callbackFunction(data);
        }).catch((error)=>{
            // @ts-ignore
          errorFunction(data);
        });
      });
    });
  }

  makeACHPayment(requestData,callbackFunction,errorFunction){
      if(requestData.nonce && requestData.amount && requestData.subscriptionId){
        let {response} = this.__createACHPayment(requestData);
        response.then((data)=>{
          for(let i=0;i<this.paymentMethods.length;i++){
            if(this.paymentMethods[i].nonce == data.nonce){
              this.paymentMethods[i].nonce = data.newNonce;
            }
          }
          callbackFunction(requestData);
        }).catch((e)=>{
          errorFunction(errorFunction);
        });
      }
  }
  isValidRoutingNumber(routingNumber){
    return (validator && validator.routingNumber) ? validator.routingNumber(routingNumber).isValid : false;
  }
  isValidAccountNumber(accountNumber){
    return (validator && validator.routingNumber) ? validator.accountNumber(accountNumber).isValid : false;
  }
}
